import { Filters, Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { SearchTypeEnum } from '__generatedTypes__/globalTypes'
import { findAllQuestionCategory, findAllQuestionCategoryVariables } from '__generatedTypes__/findAllQuestionCategory'
import { GET_LIST_QUESTION_CATEGORY } from 'queries/questionCategory'

export function castParams({ page, take, search, order }: Params<Filters>): findAllQuestionCategoryVariables {
  return {
    params: {
      skip: (page - 1) * take,
      take,
      search: search ? { query: search, type: SearchTypeEnum.ILike } : undefined,
      order: order?.field ? { [order.field]: order.direction } : undefined,
    },
  }
}

export function useQuestionCategories() {
  return useQueryWithParams<
    findAllQuestionCategory,
    findAllQuestionCategoryVariables,
    'findAllQuestionCategory',
    'items',
    'count',
    Filters
  >(GET_LIST_QUESTION_CATEGORY, 'findAllQuestionCategory', 'items', 'count', castParams, undefined, {
    fetchPolicy: 'network-only',
  })
}
